/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.germnetwork.declaration'

export { $nsid }

/** A declaration of a Germ Network account */
type Main = {
  $type: 'com.germnetwork.declaration'

  /**
   * Semver version number, without pre-release or build information, for the format of opaque content
   */
  version: string

  /**
   * Opaque value, an ed25519 public key prefixed with a byte enum
   */
  currentKey: Uint8Array

  /**
   * Controls who can message this account
   */
  messageMe?: MessageMe

  /**
   * Opaque value, contains MLS KeyPackage(s), and other signature data, and is signed by the currentKey
   */
  keyPackage?: Uint8Array

  /**
   * Array of opaque values to allow for key rolling
   */
  continuityProofs?: Uint8Array[]
}

export type { Main }

/** A declaration of a Germ Network account */
const main = l.record<'literal:self', Main>(
  'literal:self',
  $nsid,
  l.object({
    version: l.string({ minLength: 5, maxLength: 14 }),
    currentKey: l.bytes(),
    messageMe: l.optional(l.ref<MessageMe>((() => messageMe) as any)),
    keyPackage: l.optional(l.bytes()),
    continuityProofs: l.optional(l.array(l.bytes(), { maxLength: 1000 })),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type MessageMe = {
  $type?: 'com.germnetwork.declaration#messageMe'

  /**
   * A URL to present to an account that does not have its own com.germnetwork.declaration record, must have an empty fragment component, where the app should fill in the fragment component with the DIDs of the two accounts who wish to message each other
   */
  messageMeUrl: l.UriString

  /**
   * The policy of who can message the account, this value is included in the keyPackage, but is duplicated here to allow applications to decide if they should show a 'Message on Germ' button to the viewer.
   */
  showButtonTo: 'none' | 'usersIFollow' | 'everyone' | l.UnknownString
}

export type { MessageMe }

const messageMe = l.typedObject<MessageMe>(
  $nsid,
  'messageMe',
  l.object({
    messageMeUrl: l.string({ format: 'uri', minLength: 1, maxLength: 2047 }),
    showButtonTo: l.string<{
      knownValues: ['none', 'usersIFollow', 'everyone']
      minLength: 1
      maxLength: 100
    }>({ minLength: 1, maxLength: 100 }),
  }),
)

export { messageMe }
